import { Trans } from "react-i18next";
import { IconLinePause, IconLinePlaying } from "@kalodata/kds-design-icons";

interface PlaySimultaneouslyBarProps {
  /** 是否有任意视频正在播放，true 时按钮切换为「暂停」。 */
  isPlaying: boolean;
  onToggle: () => void;
}

export const PlaySimultaneouslyBar = ({ isPlaying, onToggle }: PlaySimultaneouslyBarProps) => (
  <div className="shrink-0 flex items-center justify-center p-[16px] border-t border-kds-border bg-kds-bg">
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-[6px] h-[32px] px-[12px] py-[6px] rounded-[8px] bg-kds-bg-element border border-kds-border-solid shadow-[0px_1px_3px_0px_var(--kds-shadow)] cursor-pointer"
    >
      {isPlaying ? (
        <IconLinePause size={20} className="text-kds-fg" />
      ) : (
        <IconLinePlaying size={20} className="text-kds-fg" />
      )}
      <span className="text-[14px] font-medium leading-[16px] text-kds-fg">
        {isPlaying ? <Trans>Pause Both</Trans> : <Trans>Play Both</Trans>}
      </span>
    </button>
  </div>
);
